import { Trans } from '@lingui/macro'

import * as React from 'react'

import { TFBranchPhone } from '~graphql/generated/clientGraphql'
import { PhoneLink } from '~shared/components/Phone/PhoneLink'
import { Skeleton } from '~ui/components/loadingSkeletons/Skeleton'
import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren &
  SkeletonProps & {
    branch: TFBranchPhone | undefined
    textAlign?: PropsOf<typeof Text>['textAlign']
  }

/**
 * Renders contact message with clickable link to the branch phone number:
 * - shows loading skeleton when `branch` is not defined,
 * - renders `null` if the `branch` is defined, but it has no phone number defined.
 */
export const ContactUsPhone: React.FC<TProps> = ({
  branch,
  textAlign = `center`,
  showSkeleton = false,
}) => {
  const shouldShowSkeleton = showSkeleton || !branch
  const hasPhone = Boolean(branch?.phone)

  // extracting the JSX here to keep the translation (where it is used bellow) a bit cleaner
  const branchPhoneNumber = (
    <Text as={`span`} fontStyle={`boldSemi`}>
      <PhoneLink phone={branch?.phone ?? `placeholder`} />
    </Text>
  )

  if (!hasPhone && !shouldShowSkeleton) {
    return null
  }

  return (
    <Skeleton showSkeleton={shouldShowSkeleton}>
      <Text contrast={`low`} textAlign={textAlign}>
        <Trans>Anything is not right? Let us know at {branchPhoneNumber}</Trans>
      </Text>
    </Skeleton>
  )
}
